<app-modal-shell
  [title]="'SCHOOL_DATA.TITLE'"
  [cancelLabel]="'SCHOOL_DATA.BUTTONS.CANCEL'"
  [saveLabel]="'SCHOOL_DATA.BUTTONS.OK'"
  [saveDisabled]="saveDisabled"
  (cancelClicked)="cancel()"
  (saveClicked)="save()">

  <app-school-details-form [initialData]="schoolDataInfo"></app-school-details-form>

</app-modal-shell>
